import {
  Breadcrumbs,
  Drawer as MuiDrawer,
  MenuItem as MuiMenuItem,
  Toolbar as MuiToolbar,
  breadcrumbsClasses,
  drawerClasses,
  styled,
  tabsClasses,
} from "@mui/material";

export const drawerWidth = 240;

// layout/Sidebar
export const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: "border-box",
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: "border-box",
  },
});

// layout/Header (AppNavbar)
export const Toolbar = styled(MuiToolbar)({
  width: "100%",
  padding: "12px",
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  justifyContent: "center",
  gap: "12px",
  flexShrink: 0,
  [`& ${tabsClasses.flexContainer}`]: {
    gap: "8px",
    p: "8px",
    pb: 0,
  },
});

// components/OptionsMenu
export const MenuItem = styled(MuiMenuItem)({
  margin: "2px 0",
});

// components/NavbarBreadcrumbs
export const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  [`& .${breadcrumbsClasses.separator}`]: {
    color: theme.palette.action.disabled,
    margin: 1,
  },
  [`& .${breadcrumbsClasses.ol}`]: {
    alignItems: "center",
  },
}));
